[
    {
        "versao": "1.0.0",
        "data": "25/02/2024"
    }
]